import React from "react";

interface GovtLogoProps {
  hlanguage: any;
  allImagesLink: any;
}

const base_Url = process.env.REACT_APP_BASE_URL;

const GovtLogoCarousel: React.FC<GovtLogoProps> = ({
  hlanguage,
  allImagesLink,
}) => {
  const logos = allImagesLink?.govt_Officials || [];

  // duplicate for infinite scroll
  const duplicatedLogos = [...logos, ...logos];

  return (
    <div
      style={{
        width: "100%",
        overflow: "hidden",
        background: "#ffffff",
        padding: "15px 0",
        position: "relative",
      }}
    >
      {/* Blur edges */}
      <div className="govt-blur left-blur"></div>
      <div className="govt-blur right-blur"></div>

      <style>{`
        .govt-track {
          display: flex;
          width: max-content;
          animation: govt-scroll 25s linear infinite;
        }

        .govt-logo {
          flex: 0 0 auto;
          padding: 0 40px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .govt-logo img {
          height: 60px;
          object-fit: contain;
        }

        /* Blur fade on edges */
        .govt-blur {
          position: absolute;
          top: 0;
          width: 10%;
          height: 100%;
          z-index: 5;
          pointer-events: none;
        }

        .left-blur {
          left: 0;
          background: linear-gradient(to right, white 30%, rgba(255,255,255,0));
        }

        .right-blur {
          right: 0;
          background: linear-gradient(to left, white 30%, rgba(255,255,255,0));
        }

        @keyframes govt-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }

        @media (max-width: 768px) {
          .govt-logo img {
            height: 45px;
          }
        }
      `}</style>

      <div className="govt-track mb-5">
        {duplicatedLogos.map((item: any, index: number) => (
          <div key={index} className="govt-logo">
            <img
              src={`${base_Url}${item.fileUrl}`}
              alt={item.fileName}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default GovtLogoCarousel;
